import Layout from '@/layout/index.vue'

const routes = [
  {
    path: '/',
    redirect: '/wxl',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: '/wxl',
        name: 'Home',
        meta: {
          title: '首页',
          tabbar: true,
          hideNavBar: true
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/home')
      },
      {
        path: '/user',
        name: 'User',
        meta: {
          title: '用户',
          tabbar: true,
          hideNavBar: true
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/user')
      },
      {
        path: '/setting',
        name: 'Setting',
        meta: {
          keepAlive: true,
          title: '设置'
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/setting')
      },
      {
        path: '/wwxj',
        name: 'Address',
        meta: {
          title: ''
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/address')
      }
    ]
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "about" */ '@/views/error/404'),
    meta: {
      title: '404',
      isHide: true
    }
  }
]

export default routes
